import { CommandPayload } from '../../interfaces/commands/command-payload';
import { FlowType } from '../../types/flow-types';
import { FlowParameter } from '../flow-config/flow-parameter';
import { S3ConnectorBase } from './s3-connector-base';

export class S3TestConnectionPayload {
	s3ConnectorBase: S3ConnectorBase;
	commandPayload: CommandPayload;
	flowID: string;
	flowType: FlowType;
	flowParameters: FlowParameter[];

	constructor(
		s3ConnectorBase: S3ConnectorBase,
		payload: CommandPayload,
		flowID: string,
		flowType: FlowType,
		flowParameters: FlowParameter[]
	) {
		this.s3ConnectorBase = s3ConnectorBase;
		this.commandPayload = payload;
		this.flowID = flowID;
		this.flowType = flowType;
		this.flowParameters = flowParameters;
	}
}
